import MUTIL from './MUTIL';

class Animator {
	constructor(args) {
		this.callback = args.callback || undefined;
		this.initial_value = args.value === undefined ? 0 : args.value;
		this.value = this.initial_value;
		this.target = args.target === undefined ? 1 : args.target;
		this.speed = args.speed || 1;
		this._update();
	}

	_update() {
		setTimeout(() => {
			if (this.callback) this.callback(this.value);
		}, 0);
		if (this.value === this.target) return;
		this.kill();
		const get_time = () => (new Date()).getTime() / 1000;
		const t0 = get_time();
		const t1 = t0 + (Math.abs(this.target - this.value) / this.speed);
		const start_value = this.value;
		var rq; rq = () => {
			this.anim_frame = window.requestAnimationFrame(() => {
				delete this.anim_frame;
				const t = get_time();
				if (t >= t1) {
					this.value = this.target;
				} else {
					this.value = MUTIL.rescale(t, t0, t1, start_value, this.target);
					rq();
				}
				if (this.callback) this.callback(this.value);
			});
		}
		rq();
	}

	kill() {
		if (this.anim_frame) {
			window.cancelAnimationFrame(this.anim_frame);
			delete this.anim_frame;
		}
	}

	set_target(target) {
		this.target = target;
		this._update();
	}

	set_value_and_target(value, target) {
		this.value = value;
		this.target = target;
		this._update();
	}

	reset() {
		this.value = this.initial_value;
		this._update();
	}
}

export default Animator;



// WEBPACK FOOTER //
// ./src/Animator.js